import cx from 'classnames';

import styles from './CountryFlag.module.css';
import Image from '../Image/Image';
import Box from '../Box/Box';

interface CountryFlagProps {
  className?: string;
  countryName: string;
  countryFlagSrc?: string;
  width?: number;
}

export default function CountryFlag({
  className,
  countryName,
  countryFlagSrc,
  width = 32,
}: CountryFlagProps): JSX.Element {
  const ratio = 4 / 3;

  const height = width / ratio;

  return (
    <Box className={cx(styles['base'], className)} style={{ width, height }}>
      <Image width="100%" src={countryFlagSrc} alt={countryName} />
    </Box>
  );
}
